import { useCallback } from "react";
import { ApiRoutes } from "../../../constants/apiRoutes";
import { useApi } from "../../../hooks/useApi";
import { stringify } from "query-string";
import { urlReplacer } from "../../../utils";

export default function () {
  const { request } = useApi();

  return {
    fetchAll: useCallback(
      async (filter) => {
        return request({
          method: "GET",
          url: ApiRoutes.LANGUAGE_COURSES + stringify(filter),
        });
      },
      [request],
    ),

    getLanguagesWithCourses: useCallback(
      async (filter) => {
        return request({
          method: "GET",
          url: ApiRoutes.LANGUAGES_WITH_COURSES + stringify(filter),
        });
      },
      [request],
    ),

    create: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "POST",
          url: ApiRoutes.CREATE_LANGUAGE_COURSE,
        });
      },
      [request],
    ),

    update: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "PUT",
          url: ApiRoutes.CREATE_LANGUAGE_COURSE,
        });
      },
      [request],
    ),

    checkDuplication: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "POST",
          url: ApiRoutes.CHECK_LANGUAGE_COURSE_DUPLICATION,
        });
      },
      [request],
    ),

    uploadDetailFile: useCallback(
      (file) => {
        let formData = new FormData();
        formData.append("file", file);
        return request({
          method: "POST",
          url: `${ApiRoutes.UPLOAD_LANGUAGE_COURSE_DETAIL_FILE}`,
          data: formData,
        });
      },
      [request],
    ),

    fetchOne: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_LANGUAGE_COURSE, { id })}`,
        });
      },
      [request],
    ),

    activate: useCallback(
      async (id) => {
        return request({
          method: "PUT",
          url: `${urlReplacer(ApiRoutes.ACTIVATE_LANGUAGE_COURSE, { id })}`,
        });
      },
      [request],
    ),

    deactivate: useCallback(
      async (id, data) => {
        return request({
          data: data,
          method: "PUT",
          url: `${urlReplacer(ApiRoutes.DEACTIVATE_LANGUAGE_COURSE, { id })}`,
        });
      },
      [request],
    ),

    fetchAppCount: useCallback(
      async (filter) => {
        return request({
          method: "GET",
          url: `${
            ApiRoutes.GET_APPLICATION_COUNT_FOR_DEACTIVATION_LANGUAGE_COURSE +
            stringify(filter)
          }`,
        });
      },
      [request],
    ),

    deleteOne: useCallback(
      async (id) => {
        return request({
          method: "DELETE",
          url: `${urlReplacer(ApiRoutes.DELETE_COURSE, { id })}`,
        });
      },
      [request],
    ),

    fetchViewMore: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_VIEW_MORE_LANGUAGE_COURSE, {
            id,
          })}`,
        });
      },
      [request],
    ),

    fetchCountriesContainingCourses: useCallback(() => {
      return request({
        method: "GET",
        url: `${ApiRoutes.GET_COUNTRIES_CONTAINING_COURSES}`,
      });
    }, [request]),

    fetchLanguagesContainingCourses: useCallback(() => {
      return request({
        method: "GET",
        url: `${ApiRoutes.GET_LANGUAGES_CONTAINING_COURSES}`,
      });
    }, [request]),
  };
}
